import api from '../config/api';
import { API_ENDPOINTS } from '../config/constants';

export const adminService = {
  // Get pending seller applications
  getPendingSellers: async (page = 1, limit = 20) => {
    const response = await api.get(API_ENDPOINTS.ADMIN.PENDING_SELLERS, {
      params: { page, limit },
    });
    return response.data;
  },

  // Get all sellers
  getAllSellers: async (page = 1, limit = 20, status = null) => {
    const response = await api.get(API_ENDPOINTS.ADMIN.SELLERS_ALL, {
      params: { page, limit, onboarding_status: status },
    });
    return response.data;
  },

  // Get seller application details
  getSellerDetails: async (sellerId) => {
    const response = await api.get(API_ENDPOINTS.ADMIN.GET_SELLER(sellerId));
    return response.data;
  },

  // Approve seller
  approveSeller: async (sellerId) => {
    const response = await api.post(API_ENDPOINTS.ADMIN.APPROVE_SELLER(sellerId));
    return response.data;
  },

  // Reject seller
  rejectSeller: async (sellerId, reason) => {
    const response = await api.post(API_ENDPOINTS.ADMIN.REJECT_SELLER(sellerId), {
      reason,
    });
    return response.data;
  },

  // Review document
  reviewDocument: async (sellerId, docId, status, reason = null) => {
    const response = await api.post(
      `/admin/sellers/${sellerId}/documents/${docId}/review`,
      { status, reason }
    );
    return response.data;
  },

  // Get platform analytics
  getPlatformAnalytics: async () => {
    const response = await api.get(API_ENDPOINTS.ADMIN.ANALYTICS);
    return response.data;
  },

  // Get seller subscriptions
  getSubscriptions: async (page = 1, limit = 20, tier = null, status = null) => {
    const params = { page, limit };
    if (tier) params.tier = tier;
    if (status) params.status = status;
    
    const response = await api.get('/admin/subscriptions', { params });
    return response.data;
  },

  // Get contact messages from "Contact Us" page
  getContactMessages: async (page = 1, limit = 20, isRead = null) => {
    const params = { page, limit };
    if (isRead !== null) params.is_read = isRead;
    const response = await api.get(API_ENDPOINTS.ADMIN.CONTACT_MESSAGES, { params });
    return response.data;
  },

  // Mark contact message as read
  markContactMessageRead: async (messageId) => {
    const response = await api.patch(API_ENDPOINTS.ADMIN.MARK_CONTACT_MESSAGE_READ(messageId));
    return response.data;
  },

  // Delete contact message
  deleteContactMessage: async (messageId) => {
    const response = await api.delete(`/admin/contact-messages/${messageId}`);
    return response.data;
  },
};

export default adminService;
